import { handleErrMessage } from "../../functions/handleErrMessage";
import { X } from "lucide-react";

function ErrorDisplay({ message, closeAction }) {
  return (
    <div className="flex justify-center">
      <p className="bg-red-200 text-red-1 font-figtreeMedium rounded pl-2 mt-2 relative pr-6 inline text-center max-lg:text-xs">
        {handleErrMessage(message)}
        <X
          color="red"
          className="cursor-pointer absolute right-1 top-0 max-lg:top-[-3px] pl-2"
          onClick={closeAction}
        />
      </p>
    </div>
  );
}

export default ErrorDisplay;
